import { createFileRoute } from '@tanstack/react-router';
import { AiTasksUnavailablePage } from '@/components/analytics/UnavailableAnalyticsRoutes';

export const Route = createFileRoute('/analytics/ai-tasks')({
  component: AiTasksUnavailablePage,
});
